import { render, staticRenderFns } from "./SubmitBid.vue?vue&type=template&id=5891041e&scoped=true&"
import script from "./SubmitBid.vue?vue&type=script&lang=js&"
export * from "./SubmitBid.vue?vue&type=script&lang=js&"
import style0 from "./SubmitBid.vue?vue&type=style&index=0&id=5891041e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5891041e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5891041e')) {
      api.createRecord('5891041e', component.options)
    } else {
      api.reload('5891041e', component.options)
    }
    module.hot.accept("./SubmitBid.vue?vue&type=template&id=5891041e&scoped=true&", function () {
      api.rerender('5891041e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/vendors/bids/SubmitBid.vue"
export default component.exports